import { createAction } from 'redux-actions';
import dataLayer from 'service/dataLayer';

export default createAction('TRACK_SEARCH', ({ q, totalHits }) => {
  dataLayer.trackSearch(q);
  if (!totalHits) {
    dataLayer.trackEmptySearch();
  }

  return q;
});



// WEBPACK FOOTER //
// ./src/action/trackSearch.js